export default `<div class="styles__CategoryList">
<div class="column">
   <div class="group">
      <a role="link" href="/view/boy/" title="Boys' Clothing">
         <h2 class="title">Boy</h2>
      </a>
      <ul>
         <li><a href="/view/boy/jackets/" title="Boys' Jackets"><div class="item"><div class="item-label">Jackets</div></div></a></li>
      </ul>
   </div>
   <div class="group">
      <a role="link" href="/view/girl/" title="Girls' Clothing">
         <h2 class="title">Girl</h2>
      </a>
      <ul>
         <li><a href="/view/girl/jackets/" title="Girls' Jackets"><div class="item"><div class="item-label">Jackets</div></div></a></li>
      </ul>
   </div>
</div>
</div>`